import React from 'react';

import './footer.css';

const copyWriteYear = () => {
    return (new Date()).getFullYear();
};

type FooterProps = {
    mhqp?: boolean 
};

export default function Footer( { mhqp = false }: FooterProps ) {
    
    return <footer className={`pt-5 pt-md-4 ${mhqp ? '' : 'bg-dark-blue'}`}>
        <div className='container'>
            <hr />
            <div className='row pt-4 pb-5'>
                <div className='col-12 col-lg text-center text-lg-start mb-3 mb-lg-0'>
                    <span className=''>© Copyright {copyWriteYear()} <span className='d-none d-lg-inline'>Center for the Study of Services</span><span className='d-inline d-lg-none'>CSS Research</span>
                    </span>
                </div>
                <div className='col-12 col-lg text-center text-lg-end'>
                    <a href='https://public.cssresearch.org/terms-of-service' className='pe-lg-3'>Terms of Use</a>
                    <a href='https://public.cssresearch.org/terms-of-service' className=''>Privacy Policy</a>
                </div>
            </div>
        </div>
    </footer>;
}